<template>
    <div class="wrapper-div">
        <div
            class="article-dialog extend-bottom"
            :style="{ 'max-width': width + 'px' }"
        >
            <div
                style="position: relative; top: 42px; left: 20px; width: calc(100% - 40px)"
            >
                <IconBtn
                    v-if="hasHistory"
                    @click="stepBackHistory"
                    class="primary-outlined closeBtnWrapper"
                    name="arrow-left"
                    size="lg"
                    style="float: left"
                />
                <IconBtn
                    class="primary-outlined closeBtnWrapper"
                    @click="closeDialog"
                    name="times"
                    size="lg"
                    style="float: right"
                />
            </div>
            <Paper
                style="width: 100%;"
                class="d-flex flex-column flex-grow"
                :header="payload.title"
                :offsetHeaderFromLeft="hasHistory"
                restrictHeaderWidth
            >
                <div>
                    <img :src="payload.img" class="article-img" />
                </div>
                <div class="px-5 pb-5 pt-4 article-layout flex-grow">
                    <!-- <p>Testing</p> -->
                    <!-- TODO: Do something about this loading -->

                    <div v-if="!body">{{ $t('general.loading') }}...</div>
                    <div v-else v-html="body"></div>
                </div>
                <Paper
                    :header="
                        $t('companyDetail.articles.moreArticlesFrom', {
                            companyName: company.data.name,
                        })
                    "
                    v-if="articles && articles.length > 0"
                >
                    <div v-if="!articles">{{ $t('general.loading') }}...</div>
                    <Carousel
                        v-else
                        :component="getComponent()"
                        :items="articles"
                        :noResourcesMessage="
                            $t('companyDetail.articles.noMoreArticles')
                        "
                    />
                </Paper>
            </Paper>
        </div>
    </div>
</template>

<script>
// Components
import ArticlesCarouselItem from '~/components/miscellaneous/Articles.CarouselItem';

// Utils
import AnalyticService from '~/services/AnalyticService';
import { mapArticles } from '~/utils/mappers/mediaMappers';

export default {
    name: 'Articles.DialogItem',

    props: {
        suppressLogging: Boolean,
    },

    data() {
        return {
            height: 600,
            width: 600,

            hasLoggedEvent: false, // Indicates if there has been a log of the article view
        };
    },

    computed: {
        payload() {
            return this.$interfaces.dialogModal.getState().payload;
        },

        hasHistory() {
            return this.$interfaces.dialogModal.hasHistory();
        },

        company() {
            return this.$interfaces.company
                .id(this.$route.params.id)
                .get({ reactive: true });
        },
        orgProfile() {
            if (!this.company || this.company.loading) return { loading: true };
            return this.$interfaces.organization.profile
                .id(this.company.data.externalId)
                .get({ reactive: true });
        },
        articles() {
            if (this.orgProfile.loading) return;
            return mapArticles(
                this.orgProfile.data.articles.filter(
                    it => it.id != this.payload.id
                )
            );
        },

        article() {
            return this.$interfaces.organization.article
                .id(this.payload.id)
                .get({ reactive: true });
        },
        body() {
            if (!this.article || this.article.loading) return;
            return this.article.data.body;
        },
    },

    methods: {
        closeDialog() {
            this.$interfaces.dialogModal.getState().resolver.res();
        },

        handleResizeEvent() {
            this.height = window.innerHeight * 0.9;
            this.width = window.innerWidth;
        },

        getComponent() {
            return ArticlesCarouselItem;
        },

        stepBackHistory() {
            this.$interfaces.dialogModal.popState();
        },

        async logArticleViewEvent() {
            if (this.suppressLogging) {
                return;
            }

            const article = this.article ? this.article.data : null;

            // Not log if already logged, or if there is no data to log with
            if (this.hasLoggedEvent || (!article || !article.id)) {
                return;
            }

            // Making sure the company-data is fetched before we log
            const company = await this.$interfaces.company
                .id(this.$route.params.id)
                .get();
            if (!company || !company.data || !company.data.id) {
                return;
            }

            // Start logging
            this.hasLoggedEvent = true;
            AnalyticService.articleViewEvent(
                article.id,
                company.data.id,
                article.title
            );
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();

        // Logging article view event. Will not log if the data is not in there store.
        // Therefore, this method is also being called in watch when the data has been fetched.
        this.logArticleViewEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },

    watch: {
        article(newArticle, oldArticle) {
            if (!this.hasLoggedEvent || newArticle.ids !== oldArticle.ids) {
                this.logArticleViewEvent();
            }
        },
    },
};
</script>

<style lang="css" scoped>
.article-dialog {
    max-width: var(--grid-width);
    width: var(--grid-width);
    margin: 0 auto;
}

.wrapper-div {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

.article-img {
    width: 100%;
    max-height: 600px;
    object-fit: cover;
    padding: 12px;
}
</style>
